import { Text, View } from "@react-pdf/renderer";
import Column from "./column";

function DriverSchedule({ driversData }) {
  return (
    <View
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        marginTop: 30,
        width: "100%",
      }}
    >
      <Text style={{ fontWeight: 600, fontSize: 30 }}>Driver Schedule</Text>

      <View
        style={{
          maxWidth: 1000,
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "row",
          marginTop: 20,
        }}
      >
        <View
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            border: "1.5px solid black",
            flexDirection: "row",
          }}
        >
          <Column columnName="First" items={driversData.dFirstName} />
          <Column columnName="Last" items={driversData.dLastName} />
          <Column columnName="L. State" items={driversData.dLState} />
          <Column columnName="L. Number" items={driversData.dLNumber} />
          <Column columnName="Birth" items={driversData.dBirthDate} />
          <Column columnName="Yrs. Exp" items={driversData.dYrsExp} />
          <Column columnName="Hire" items={driversData.dHire} />
          <Column columnName="Accidents" items={driversData.dAccidents} />
          <Column columnName="Violations" items={driversData.dViolations} />
          <Column columnName="Suspensions" items={driversData.dSuspensions} />
          <Column columnName="Excluded" items={driversData.dEligibility} />
        </View>
      </View>
    </View>
  );
}
export default DriverSchedule;
